import { useSelector } from 'react-redux';
import { selectUserRbacPermissions } from 'core/userContext';
import { MessageMedium } from 'modules/domains/campaign';
import { PROJECT_PERMISSIONS, canManageMessagingByMedium } from 'utils/permissions';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';

export const useExperimentsUserPermission = (messageMedium?: MessageMedium) => {
  const permissions = useSelector(selectUserRbacPermissions);
  const UseChannelBasedPermissions = useFeatureFlag('UseChannelBasedPermissions', false);

  const canViewMessaging = permissions.includes(PROJECT_PERMISSIONS.ViewMessaging);
  const canDraftMessaging = permissions.includes(PROJECT_PERMISSIONS.DraftMessaging);
  const canManageMessaging = canManageMessagingByMedium(
    permissions,
    messageMedium,
    UseChannelBasedPermissions,
  );

  const viewOnlyPermission = canViewMessaging && !canDraftMessaging && !canManageMessaging;
  const viewAndDraftPermission = canViewMessaging && canDraftMessaging && !canManageMessaging;

  return {
    viewOnlyPermission,
    viewAndDraftPermission,
    nonManageAndLaunchPermission: viewOnlyPermission || viewAndDraftPermission,
    manageAndLaunchPermission: canViewMessaging && canDraftMessaging && canManageMessaging,
  };
};
